/** When your routing erp is too long, you can split it into small modules **/
export default [
    {
      path: 'users/editShop',
      name: 'EditShop',
      component: () => import('@/views/erp/users/shop/edit/index.vue')
    },
  ]
  